type LookupMode = "license" | "name" | null;

export const ADDITIONAL_BUSINESS_REQUIRED_PLAN = 2;

export function hasAdditionalBusinessPlanAccess(
  providerUser: { isPlatformAdmin?: boolean } | null | undefined,
  effectivePlan: number
): boolean {
  return providerUser?.isPlatformAdmin === true || effectivePlan >= ADDITIONAL_BUSINESS_REQUIRED_PLAN;
}

export function canStartNewBusinessProfile({
  businessCategoryId,
  requiresHealthcareLookup,
  lookupMode,
  requiresBusinessNameLookup,
  businessAuthorityConfirmed,
}: {
  businessCategoryId?: string | number | null;
  requiresHealthcareLookup: boolean;
  lookupMode?: LookupMode;
  requiresBusinessNameLookup: boolean;
  businessAuthorityConfirmed: boolean;
}): boolean {
  if (!businessCategoryId) return false;
  if (requiresHealthcareLookup && !lookupMode) return false;
  if (requiresBusinessNameLookup && !businessAuthorityConfirmed) return false;
  return true;
}
